// app/javascript/controllers/amount_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("input", this.validateAmount.bind(this))
  }

  validateAmount() {
    const amountInput = this.element
    const sanitizedValue = amountInput.value.replace(/,/g, ".")

    if (sanitizedValue !== amountInput.value) {
      amountInput.value = sanitizedValue
    }
  }
}
